








import {Component, Vue, Prop, Watch} from "vue-property-decorator";

@Component
export default class ItemText extends Vue {

  @Prop() public title!: string
  @Prop() public index!: number
  @Prop() public disabled!: boolean;
  @Prop() public description!: string
  @Prop() public split!: boolean;
  @Prop() public titleFontSize!: number;
  @Prop() public titleColor!: string;
  @Prop() public descriptionFontSize!: number;
  @Prop() public descriptionColor!: string;
}

